import useScript from 'hooks/useScript';
import { useSelector } from 'react-redux';
import getConfigurationByKey from 'store/app/selector/getConfigurationByKey';

const ExternalScriptLoader = () => {
  if (process.env.RAZZLE_ENV === 'local') {
    // For debugging on local
    useScript('//localhost:4200/polyfills.js');
    useScript('//localhost:4200/main.js');
    return null;
  }
  const OPUIUrl = useSelector(getConfigurationByKey('OPTIMALPRINT_UI_SDK_URL'), (value) => value || '');
  useScript(OPUIUrl);
  useScript('//assets.pxlecdn.com/assets/pixlee_widget_1_0_0.js');
  return null;
};

export default ExternalScriptLoader;
